//import router from "@/router";
import Cookies from "js-cookie";
import { getUrlParams, initLocalName } from "@/utils";

const state = {
  browserFinger: localStorage.getItem("browserFinger")
    ? localStorage.getItem("browserFinger")
    : "", //浏览器id
  API_TOKEN:
    process.env.NODE_ENV == "development" ? process.env.VUE_APP_API_TOKEN : "", //getToken(),
  name: "", //用户名
  loginInfo: {}, //登陆后的信息
  SHowMainHead: false, // 是否显示主页面中的头部栏
  SHowTopHead: true, //是否显示系统顶部栏
  urlId: getUrlParams("url_id") ? getUrlParams("url_id") : "",
  selectedType: getUrlParams("brand_id")
    ? getUrlParams("brand_id").split(",")
    : [], // 页面顶部下拉框中选中的品牌类型ID
  brandName: getUrlParams("brand_name")
    ? getUrlParams("brand_name").split(",")
    : [], // 页面顶部下拉框中选中的品牌类型名称
  topicName: getUrlParams("topic_name")
    ? getUrlParams("topic_name").split(",")
    : [], // 页面顶部下拉框中选中的话题名称
  selectedKeyWards: getUrlParams("word") ? getUrlParams("word") : "", //页面顶部输入框中输入的搜索条件
  catId: getUrlParams("cat_id") ? getUrlParams("cat_id") : "", //选择的类目ID
  catName:
    getUrlParams("cat_id") && getUrlParams("cat_name")
      ? getUrlParams("cat_name")
      : "", //选择的类目名称
  ruleId: getUrlParams("rule_id") ? getUrlParams("rule_id") : "", //规则ID
  analyseTyp: getUrlParams("analyse_typ") ? getUrlParams("analyse_typ") : "", //规则名称
  routerRuleId: getUrlParams("r_rule_id") ? getUrlParams("r_rule_id") : "", //头部筛选条件的规则ID
  routerAnalyseTyp: getUrlParams("r_analyse_typ")
    ? getUrlParams("r_analyse_typ")
    : "", //头部筛选条件的规则名称
  words: getUrlParams("words") ? getUrlParams("words") : "", //头部筛选条件选中声量图表数据的名称
  labelLevel: getUrlParams("label_level") ? getUrlParams("label_level") : "", //头部筛选条件选中声量的等级
  aspectType: getUrlParams("aspect_type") ? getUrlParams("aspect_type") : "", //头部筛选条件选中声量的类型(全部,正向,负向)
  kolType: getUrlParams("kol_type")
    ? getUrlParams("kol_type").split(",")
    : ["consumer", "koc", "kol"], //选择的作者
  plants: getUrlParams("plat")
    ? getUrlParams("plat").split(",")
    : ["douyin", "weibo", "xhs"], //选择的平台
  KolId: getUrlParams("kol_id") ? getUrlParams("kol_id") : "", //选择的达人ID
  KolName: getUrlParams("kol_name") ? getUrlParams("kol_name") : "", //选择的达人名称
  post_kolId: "", //帖子达人榜ID
  post_KolName: "", //帖子达人榜名称
  startMonth: getUrlParams("start") ? getUrlParams("start") : "", //开始月份
  endMonth: getUrlParams("end") ? getUrlParams("end") : "", //结束月份
  //logingState: true, //登陆过状态 false:未登录  true:已登录
  ActivedMnenue: "1-1", //当前选中的menue
  ActivedTab: getUrlParams("passActivedTab")
    ? getUrlParams("passActivedTab")
    : "BaseInfo", //当前选中的tab
  CloudWord: getUrlParams("CloudWord") ? getUrlParams("CloudWord") : "", //选中的次云 用于查询帖子列表
  brand_id2: getUrlParams("postBrandId") ? getUrlParams("postBrandId") : "", //用于查询帖子列表
  post_brand_name: getUrlParams("postBrandName")
    ? getUrlParams("postBrandName")
    : "", // 用于查询帖子列表
  navContent: [], //nav的tab数据
  navHideContent: [], //nav隐藏的tab数据
  headProductList: localStorage.getItem("SJ_HEAD_PRODUCT_LIST")
    ? JSON.parse(localStorage.getItem("SJ_HEAD_PRODUCT_LIST"))
    : [], //产品价值数据
  headProductActive: {}, //当前选中的产品价值
  headProductIsShow: false, //是否显示产品价值栏
  headProductCompletedMove: false, //触发了解价值点后的动效
  urlParams: {},
  tsType: "month",
};

const mutations = {
  SET_BROWSER_FINGER: (state, data) => {
    state.browserFinger = data;
  },
  SET_API_TOKEN: (state, data) => {
    state.API_TOKEN = data;
  },
  SET_SHOW_MAIN_HEAD: (state, data) => {
    state.SHowMainHead = data;
  },
  SET_SHOW_TOP_HEAD: (state, data) => {
    state.SHowTopHead = data;
  },
  SET_URL_ID: (state, data) => {
    state.urlId = data;
  },
  SET_SELECTED_TYPE: (state, data) => {
    state.selectedType = data;
  },
  SET_SELECTED_NAME: (state, data) => {
    state.brandName = data;
  },
  SET_TOPIC_NAME: (state, data) => {
    state.topicName = data;
  },
  SET_LOGININFO: (state, data) => {
    state.loginInfo = data;
  },
  SET_SELECTED_KEYWARDS: (state, data) => {
    state.selectedKeyWards = data;
  },
  SET_KOL_TYPE: (state, data) => {
    state.kolType = data;
  },
  SET_PLANTS: (state, data) => {
    state.plants = data;
  },
  SET_CAT_ID: (state, data) => {
    state.catId = data;
  },
  SET_CAT_NAME: (state, data) => {
    state.catName = data;
  },
  SET_RULE_ID: (state, data) => {
    state.ruleId = data;
  },
  SET_ROUTER_RULE_ID: (state, data) => {
    state.routerRuleId = data;
  },
  SET_ANALYSE_TYP: (state, data) => {
    state.analyseTyp = data;
  },
  SET_ROUTER_ANALYSE_TYP: (state, data) => {
    state.routerAnalyseTyp = data;
  },
  SET_WORDS: (state, data) => {
    state.words = data;
  },
  SET_LABEL_LEVEL: (state, data) => {
    state.labelLevel = data;
  },
  SET_ASPECT_TYPE: (state, data) => {
    state.aspectType = data;
  },
  SET_KOL_ID: (state, data) => {
    state.KolId = data;
  },
  SET_KOL_NAME: (state, data) => {
    state.KolName = data;
  },
  SET_POST_KOL_ID: (state, data) => {
    state.post_kolId = data;
  },
  SET_POST_KOL_NAME: (state, data) => {
    state.post_KolName = data;
  },
  SET_START_MONTH: (state, data) => {
    state.startMonth = data;
  },
  SET_END_MONTH: (state, data) => {
    state.endMonth = data;
  },
  SET_ACTIVED_MENUE: (state, data) => {
    state.ActivedMnenue = data;
  },
  SET_ACTIVED_TAB: (state, data) => {
    state.ActivedTab = data;
  },
  SET_CLOUD_WORD: (state, data) => {
    state.CloudWord = data;
  },
  SET_BRAND_ID2: (state, data) => {
    state.brand_id2 = data;
  },
  SET_POST_BRAND_NAME: (state, data) => {
    state.post_brand_name = data;
  },
  SET_IDS: (state, data) => {
    state.ids = data;
  },
  SET_NAV_CONTENT: (state, data) => {
    state.navContent = data;
  },
  SET_NAV_HIDE_CONTENT: (state, data) => {
    state.navHideContent = data;
  },
  SET_HEAD_PRODUCT_LIST: (state, data) => {
    state.headProductList = data;
  },
  SET_HEAD_PRODUCT_ACTIVE: (state, data) => {
    state.headProductActive = data;
  },
  SET_HEAD_PRODUCT_IS_SHOW: (state, data) => {
    state.headProductIsShow = data;
  },
  SET_HEAD_PRODUCT_COMPLETED_MOVE: (state, data) => {
    state.headProductCompletedMove = data;
  },
  SET_URL_PARAMS: (state, data) => {
    state.urlParams = data;
  },
  SET_TS_TYPE: (state, data) => {
    state.tsType = data;
  },
};

const actions = {
  changeBrowserFinger({ commit, dispatch }, data) {
    commit("SET_BROWSER_FINGER", data);
  },
  changeApiToken({ commit, dispatch }, data) {
    commit("SET_API_TOKEN", data);
  },
  changeShowMainHead({ commit, dispatch }, data) {
    commit("SET_SHOW_MAIN_HEAD", data);
  },
  changeShowTopHead({ commit, dispatch }, data) {
    commit("SET_SHOW_TOP_HEAD", data);
  },
  changeLoginInfo({ commit, dispatch }, data) {
    commit("SET_LOGININFO", data);
  },
  changeUrlId({ commit, dispatch }, data) {
    commit("SET_URL_ID", data);
  },
  changeSelectedType({ commit, dispatch }, data) {
    commit("SET_SELECTED_TYPE", data);
  },
  changeBrandName({ commit, dispatch }, data) {
    commit("SET_SELECTED_NAME", data);
  },
  changeTopicName({ commit, dispatch }, data) {
    commit("SET_TOPIC_NAME", data);
  },
  changeSelectedKeyWards({ commit, dispatch }, data) {
    commit("SET_SELECTED_KEYWARDS", data);
  },
  changeKolType({ commit, dispatch }, data) {
    commit("SET_KOL_TYPE", data);
  },
  changeplants({ commit, dispatch }, data) {
    commit("SET_PLANTS", data);
  },
  changeCatId({ commit, dispatch }, data) {
    commit("SET_CAT_ID", data);
  },
  changeCatName({ commit, dispatch }, data) {
    commit("SET_CAT_NAME", data);
  },
  changeAnalyseTyp({ commit, dispatch }, data) {
    commit("SET_ANALYSE_TYP", data);
  },
  changeRouterAnalyseTyp({ commit, dispatch }, data) {
    commit("SET_ROUTER_ANALYSE_TYP", data);
  },
  changeWords({ commit, dispatch }, data) {
    commit("SET_WORDS", data);
  },
  changeLabelLevel({ commit, dispatch }, data) {
    commit("SET_LABEL_LEVEL", data);
  },
  changeAspectType({ commit, dispatch }, data) {
    commit("SET_ASPECT_TYPE", data);
  },
  changeRuleId({ commit, dispatch }, data) {
    commit("SET_RULE_ID", data);
  },
  changeRouterRuleId({ commit, dispatch }, data) {
    commit("SET_ROUTER_RULE_ID", data);
  },
  changeKolId({ commit, dispatch }, data) {
    commit("SET_KOL_ID", data);
  },
  changeKolName({ commit, dispatch }, data) {
    commit("SET_KOL_NAME", data);
  },
  changePostKolId({ commit, dispatch }, data) {
    commit("SET_POST_KOL_ID", data);
  },
  changePostKolName({ commit, dispatch }, data) {
    commit("SET_POST_KOL_NAME", data);
  },
  changeStartMonth({ commit, dispatch }, data) {
    commit("SET_START_MONTH", data);
  },
  changeEndMonth({ commit, dispatch }, data) {
    commit("SET_END_MONTH", data);
  },
  changeActivedMnenue({ commit, dispatch }, data) {
    commit("SET_ACTIVED_MENUE", data);
  },
  changeActivedTab({ commit, dispatch }, data) {
    commit("SET_ACTIVED_TAB", data);
  },
  changeCloudWord({ commit, dispatch }, data) {
    commit("SET_CLOUD_WORD", data);
  },
  changeBrandId2({ commit, dispatch }, data) {
    commit("SET_BRAND_ID2", data);
  },
  changePostBrandName({ commit, dispatch }, data) {
    commit("SET_POST_BRAND_NAME", data);
  },
  changeIds({ commit, dispatch }, data) {
    commit("SET_IDS", data);
  },
  changeNavContent({ commit, dispatch }, data) {
    commit("SET_NAV_CONTENT", data);
  },
  changeNavHideContent({ commit, dispatch }, data) {
    commit("SET_NAV_HIDE_CONTENT", data);
  },
  changeHeadProductList({ commit, dispatch }, data) {
    commit("SET_HEAD_PRODUCT_LIST", data);
  },
  changeHeadProductActive({ commit, dispatch }, data) {
    commit("SET_HEAD_PRODUCT_ACTIVE", data);
  },
  changeHeadProductIsShow({ commit, dispatch }, data) {
    commit("SET_HEAD_PRODUCT_IS_SHOW", data);
  },
  changeHeadProductCompletedMove({ commit, dispatch }, data) {
    commit("SET_HEAD_PRODUCT_COMPLETED_MOVE", data);
  },
  changeUrlParams({ commit, dispatch }, data) {
    commit("SET_URL_PARAMS", data);
  },
  changeTsType({ commit, dispatch }, data) {
    commit("SET_TS_TYPE", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
